import { render, staticRenderFns } from "./AppointmentType.vue?vue&type=template&id=191c1c5c&scoped=true&"
import script from "./AppointmentType.vue?vue&type=script&lang=js&"
export * from "./AppointmentType.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentType.vue?vue&type=style&index=0&id=191c1c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c1c5c",
  null
  
)

export default component.exports